<script>
import Utils from "@/services/utils.js";
import Button2 from "@/components/ui/Button2";
import ProfileIcon from "@/components/profiles/ProfileIcon";
import ChannelIcon from "./ChannelIcon";
import ChannelValidation from "./ChannelValidation";
import { checkValidation } from "../check-validation";
import { CHANNEL_TYPE } from "./enum-channel-type"

export default {
  name: "ChannelRow",
  components: {
    Button2,
    ChannelIcon,
    ChannelValidation,
    ProfileIcon
  },
  props: {
    channel: {
      type: Object,
    },
  },
  data: function () {
    return {
      CHANNEL_TYPE,
      canReadChannels: Utils.can("beepiz-read-channels"),
      canUpdateChannels: Utils.can("beepiz-update-channels"),
      channelData: this.channel,
    };
  },
  methods: {
    arrayLength: function (array) {
      return array && array?.length || 0;
    },
    checkValidation,
    onChannelFetched: function (fetchedChannel) {
      this.channelData = fetchedChannel;
    },
  },
  computed: {
    validationStatusColor() {
      return checkValidation(this.channelData)[0] ? 'text-success' : 'text-danger'
    },
  },
  watch: {
    channel: function (newChannel) {
      this.channelData = newChannel;
    },
  },
};
</script>

<template>
  <tr v-if="canReadChannels">
    <td class="p-2 text-truncate" style="min-width: 80px">
      <ChannelIcon
        :type="channelData.type"
        :class="validationStatusColor"
        class="mr-2"
      />
      <span v-if="channelData.type === CHANNEL_TYPE.MOBILE">
        {{ $t("watchmen.channels.type.mobile") }}
      </span>
      <span v-if="channelData.type === CHANNEL_TYPE.PHONE">
        {{ $t("watchmen.channels.type.phone") }}
      </span>
      <span v-if="channelData.type === CHANNEL_TYPE.EMAIL">
        {{ $t("watchmen.channels.type.email") }}
      </span>
    </td>
    <td class="p-2">
      <div 
        class="text-mono text-truncate" 
        :title="channelData.value"
        v-text="channelData.value"
      ></div>
    </td>
    <td class="p-2">
      <ChannelValidation :channel="channel" @onChannelFetched="onChannelFetched" />
    </td>
    <td class="p-2">
      <div v-if="arrayLength(channelData.profiles)" class="d-flex flex-column" style="gap: 4px">
        <div v-for="profile in channelData.profiles">
          <router-link
            :to="`/configurations/profiles/${profile.id}`"
            class="d-flex align-items-center"
          >
            <ProfileIcon :icon="profile.icon" class="mr-2" />
            <span class="text-truncate">{{ profile.name }}</span>
          </router-link>
        </div>
      </div>
    </td>
    <td class="p-2">
      <div v-if="arrayLength(channelData.rmProcedures)">
        <i class="fa fa-lock fa-lg" aria-hidden="true"></i>
        <div v-for="rmProcedure in channelData.rmProcedures" class="text-truncate">
          <router-link
            :to="{ name: 'RemoteMonitoringShow', params: { id: rmProcedure.id }
        }"
            class="text-truncate"
          >
            {{ rmProcedure.name }}
          </router-link>
        </div>
      </div>
    </td>
    <td class="p-2">
      <Button2
        v-if="canUpdateChannels"
        class="btn-sm btn-light"
        @click.native.prevent="$emit('onEditChannel', channelData.id)"
        :disabled="arrayLength(channelData.rmProcedures) || false"
      >
        {{ $t("global.edit") }}
      </Button2>
    </td>
  </tr>
</template>
